import React from 'react';
import { ConfirmModal, Icon, useModalContext } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import * as S from './MiniRecommendationDismissButton.styled';
export const MiniRecommendationDismissButton = ({ onDismiss }) => {
    const modal = useModalContext();
    const handleDismiss = (event) => {
        event.stopPropagation();
        modal.open(ConfirmModal, {
            title: 'Are you sure you want to hide this recommendation?',
            text: 'This action cannot be reversed.',
            confirmLabel: 'Hide recommendation',
            onConfirm: () => {
                onDismiss();
            },
        });
    };
    return (React.createElement(S.CloseButton, { "aria-label": "Close", type: "button", onClick: handleDismiss },
        React.createElement(Icon, { component: CloseIcon, height: 12 })));
};
